import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ListMemberPutNumber, {
  PutNumberEntry,
} from '../ListMemberPutNumber/ListMemberPutNumber'
import ComponentHeader from '../ComponentHeader/ComponentHeader'
import PanelSurface from '../PanelSurface/PanelSurface'
import styles from './YeekeeResultV2.module.css'
export type Section = {
  title: string
  numbers: string | number
}
export type YeekeeResultV2Props = {
  putNumbers: string[]
  roundNumber: number
  sectionResult: Section[]
  bonusReward: Section[]
  // Props for ListMemberPutNumber
  memberPutNumbers?: {
    entries: PutNumberEntry[]
    currentPage: number
    totalPages: number
    onPageChange: (page: number) => void
    isLoading?: boolean
  }
}
const YeekeeResultV2: FC<YeekeeResultV2Props> = ({
  putNumbers,
  bonusReward,
  sectionResult,
  memberPutNumbers,
}) => {
  const { t } = useTranslation()
  return (
    <div className="space-y-6">
      <div
        className={`grid gap-4 grid-cols-1 lg:grid-cols-2 ${styles.resultGrid}`}
      >
        <div className="space-y-4">
          <PanelSurface className={styles.resultPanel}>
            <ComponentHeader className="px-6">
              {t('betResult.result')}
            </ComponentHeader>
            <div className="px-4 md:px-8 py-4 md:py-6 space-y-6">
              <div className={`text-center lg:text-left ${styles.resultLabel}`}>
                <span className="text-[var(--card-subtext)]">
                  {t('betResult.result_yeekee_number')}
                </span>
              </div>
              <div
                className={`flex flex-wrap gap-1 sm:gap-2 justify-center lg:justify-start ${styles.resultNumbers}`}
              >
                {putNumbers.map((number: string, index: number) => (
                  <div
                    key={index}
                    className="result-number result-number-style flex items-center justify-center"
                  >
                    <h4 className="text-2xl font-bold min-w-[1rem] text-center">
                      {number}
                    </h4>
                  </div>
                ))}
              </div>
              <div className={`grid grid-cols-2 gap-8 ${styles.sectionGrid}`}>
                {sectionResult.map((section, index) => (
                  <div
                    className="space-y-1"
                    key={index + section.title + section.numbers}
                  >
                    <span className="text-[var(--card-subtext)]">
                      {section.title}
                    </span>
                    <div>
                      <span className="text-[var(--bet-type-hover-text)] text-2xl font-medium">
                        {section.numbers}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </PanelSurface>
          <PanelSurface className={styles.resultPanel}>
            <ComponentHeader className="px-6">
              {t('betResult.bonus_reward')}
            </ComponentHeader>
            <div
              className={`px-4 md:px-8 py-4 md:py-6 grid grid-cols-1 sm:grid-cols-2 gap-6 ${styles.bonusGrid}`}
            >
              {bonusReward.map((section, index) => (
                <div
                  className="space-y-1"
                  key={index + section.title + section.numbers}
                >
                  <span className="text-[var(--card-subtext)]">
                    {section.title}
                  </span>
                  <div>
                    <span className="text-[var(--bet-type-hover-text)] text-2xl font-medium">
                      {section.numbers}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </PanelSurface>
        </div>
        <ListMemberPutNumber
          entries={memberPutNumbers?.entries ?? []}
          currentPage={memberPutNumbers?.currentPage ?? 1}
          totalPages={memberPutNumbers?.totalPages ?? 1}
          onPageChange={memberPutNumbers?.onPageChange ?? (() => {})}
          isLoading={memberPutNumbers?.isLoading}
        />
      </div>
    </div>
  )
}

export default YeekeeResultV2
